export const server = process.env.REACT_APP_BACKEND;
export const p2pStream = process.env.REACT_APP_P2P_STREAM;
export const rtmpIngestBase =
  process.env.REACT_APP_RTMP_INGEST_BASE || "rtmp://stream.iotwebhub.net/live/";
